if (!customElements.get('adev-variant-picker-v2')) {
    customElements.define('adev-variant-picker-v2', class adevVariantPickerV2 extends HTMLElement {
        constructor() {
            super();

            const quantityEl = this.closest('adev-main-product').querySelector('[data-adev-main-product="variant-option-value"]:checked');
            this.goalQuantity = parseInt(quantityEl.dataset.quantity);

            this.totalQuantity = 0;

            const jsonEl = this.querySelector('[data-adev-variant-picker-v2="json"]');
            this.variantsData = JSON.parse(jsonEl.innerHTML);

            // console.log(this.variantsData);
            

            this.updateAvailability();
        }

        isValid(){
            return this.totalQuantity === this.goalQuantity;
        }

        getErrorMessage(){
            return `Please select exactly ${this.goalQuantity} items. You have selected ${this.totalQuantity}.`;
        }

        resetInputs(){
            this.totalQuantity = 0;

            this.querySelectorAll('[data-adev-variant-picker-v2="item"]').forEach( itemEl => {
                const qtyInput = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-value"]');
                qtyInput.value = 0;
                qtyInput.dispatchEvent(new Event('change'));
            });
        }

        getHiddenInput(name, value){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            return input;
        }

        renderInputs(){
            clearTimeout(this._renderTimeout);

            this._renderTimeout = setTimeout( () => {
                const formInputsContainer = this.querySelector('[data-adev-variant-picker-v2="form-inputs"]');
                formInputsContainer.innerHTML = '';

                const timestamp = Date.now();

                const items = Array.from(this.querySelectorAll('[data-adev-variant-picker-v2="item"].has--qty')).reverse();

                let index = 0;
                items.forEach(itemEl => {
                    const value = itemEl.dataset.value;
                    const selectedVariant = this.variantsData.find(variant => variant.option1 === value);
                    const quantityInput = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-value"]');
                    const quantityValue = parseInt(quantityInput.value);

                    const itemIdInput = this.getHiddenInput(`items[${index}][id]`, selectedVariant.id);
                    const itemQtyInput = this.getHiddenInput(`items[${index}][quantity]`, quantityValue);
                    const propertyInput1 = this.getHiddenInput(`items[${index}][properties][__adev_is_bundle_item]`, 'true');
                    const propertyInput2 = this.getHiddenInput(`items[${index}][properties][__adev_main_bundle_product_id]`, this.dataset.productId);
                    const propertyInput3 = this.getHiddenInput(`items[${index}][properties][__timestamp]`, timestamp);

                    formInputsContainer.appendChild(itemIdInput);
                    formInputsContainer.appendChild(itemQtyInput);
                    formInputsContainer.appendChild(propertyInput1);
                    formInputsContainer.appendChild(propertyInput2);
                    formInputsContainer.appendChild(propertyInput3);

                    index += 1;
                });

                const adevMainProduct = this.closest('adev-main-product');
                const adevMainProductVariant = adevMainProduct.getCurrentVariant();

                const mainProductIdInput = this.getHiddenInput(`items[${index}][id]`, adevMainProductVariant.id);
                const mainProductQtyInput = this.getHiddenInput(`items[${index}][quantity]`, 1);
                const mainProductPropertyInput = this.getHiddenInput(`items[${index}][properties][__timestamp]`, timestamp);
                const mainproductIsMain = this.getHiddenInput(`items[${index}][properties][__adev_is_main_bundle_product]`, 'true');

                let flavors = [];
                this.querySelectorAll('[data-adev-variant-picker-v2="item"].has--qty').forEach( (itemEl) => {
                    const value = itemEl.dataset.value;

                    const quantityInput = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-value"]');
                    const quantityValue = parseInt(quantityInput.value);

                    flavors.push({
                        name: value,
                        quantity: quantityValue
                    });
                });

                const comma_separated_flavors = flavors.map( flavor => {
                    return `${flavor.name} x${flavor.quantity}`;
                }).join(', ');

                const mainProductPropertiesInput = this.getHiddenInput(`items[${index}][properties][Flavors]`, comma_separated_flavors);
                formInputsContainer.appendChild(mainProductPropertiesInput);

                formInputsContainer.appendChild(mainProductIdInput);
                formInputsContainer.appendChild(mainProductQtyInput);
                formInputsContainer.appendChild(mainProductPropertyInput);
                formInputsContainer.appendChild(mainproductIsMain);

            }, 50);
        }

        initQuantityVariant(){
            this.closest('adev-main-product').querySelectorAll('[data-adev-main-product="variant-option-value"]').forEach( qtyEl => {
                
                qtyEl.addEventListener('change', (e) => {
                    let qty = parseInt(e.target.dataset.quantity);

                    this.goalQuantity = qty;
                    this.resetInputs();
                    this.updateAvailability();
                });

            });
        }

        updateAvailability(){
            this.querySelectorAll('[data-adev-variant-picker-v2="item"]').forEach( itemEl => {
                const value = itemEl.dataset.value;
                const inventoryQty = parseInt(itemEl.dataset.max);

                const inputValue = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-value"]');

                const selectedVariant = this.variantsData.find( variant => {
                    return variant.option1 === value;
                });

                let max = inventoryQty;

                if (selectedVariant && selectedVariant.available) {
                    const cartQty = this.getCartQty(selectedVariant.id);

                    if (cartQty > 0) {
                        const remaining = Math.max(0, inventoryQty - cartQty);
                        inputValue.setAttribute('max', remaining);
                        inputValue.setAttribute('data-max', remaining);
                        max = remaining;
                    }
                    
                    if (max <= 0) {
                        itemEl.classList.add('is--sold-out');
                        return;
                    }

                    itemEl.classList.remove('is--sold-out');
                } else {
                    itemEl.classList.add('is--sold-out');
                }
            });
        }

        getCartQty(variantId){
            let qty = 0;

            if (window.adev_cart && window.adev_cart.items) {
                const variantQty = window.adev_cart.items.reduce( (total, item) => {
                    if (item.variant_id === variantId) {
                        return total + item.quantity;
                    }

                    return total;
                }, 0);

                qty += variantQty;
            }

            return qty;
        }


        initItems(){
            this.querySelectorAll('[data-adev-variant-picker-v2="item"]').forEach( itemEl => {

                const qty = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-picker"]');
                const increase = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-increase"]');
                const decrease = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-decrease"]');
                const qtyInput = itemEl.querySelector('[data-adev-variant-picker-v2="item-qty-value"]');

                qtyInput.addEventListener('change', (e) => {
                    let newQty = parseInt(e.target.value);
                    const max = parseInt( qtyInput.getAttribute('data-max') );

                    if (isNaN(newQty) || newQty < 0) {
                        newQty = 0;
                    }

                    if (newQty >= max) {
                        itemEl.classList.add('has--qty-limit-reached');
                        newQty = max;
                    } else {
                        itemEl.classList.remove('has--qty-limit-reached');
                    }

                    if (newQty > 0) {
                        itemEl.classList.add('has--qty');
                    } else {
                        itemEl.classList.remove('has--qty');
                    }

                    if (this.goalQuantity > this.totalQuantity) {
                        this.querySelectorAll('[data-adev-variant-picker-v2="item"]').forEach( el => {
                            el.classList.remove('has--limit-reached');
                        });
                    } else {
                        this.querySelectorAll('[data-adev-variant-picker-v2="item"]').forEach( el => {
                            el.classList.add('has--limit-reached');
                        });
                    }

                    this.renderInputs();
                    this.updateAvailability();

                });

                increase.addEventListener('click', (e) => {
                    e.preventDefault();

                    let currentQty = parseInt(qtyInput.value);
                    currentQty += 1;

                    if (this.totalQuantity + 1 > this.goalQuantity) {
                        return;
                    }

                    this.totalQuantity += 1;

                    qtyInput.value = currentQty;
                    qtyInput.dispatchEvent(new Event('change'));
                });

                decrease.addEventListener('click', (e) => {
                    e.preventDefault();

                    let currentQty = parseInt(qtyInput.value);

                    if (currentQty <= 0) {
                        return;
                    }
                    
                    if(currentQty > 0){
                        currentQty -= 1;
                    }

                    if (this.totalQuantity - 1 < 0) {
                        return;
                    }

                    this.totalQuantity -= 1;

                    qtyInput.value = currentQty;
                    qtyInput.dispatchEvent(new Event('change'));
                });

                itemEl.classList.add('is--ready');

            });
        }

        init(){
            this.initQuantityVariant();
            this.initItems();

            this.addEventListener('adev:update-availability', () => {
                console.log('adev:update-availability');
                fetch(window.routes.root + `cart.js?timestamp=${Date.now()}`)
                .then( res => res.json() )
                .then( cart => {
                    window.adev_cart = cart;
                    this.updateAvailability();
                })
                .catch( err => {
                    console.log('Error fetching cart data:', err);
                });
            });

            document.addEventListener('adev:cart:updated', (event) => {
                console.log('cart refreshed');
                
                this.dispatchEvent(new Event('adev:update-availability'));
            });
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            
        }

    });
}